
const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async updateTag({ dispatch }, tag) {
    const dbTag = await dispatch(`model/tag/updateTag`, tag, { root: true });

    return dbTag;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
